import React, { Component } from "react";

import Footer from "../Layout/Footer";

import OAuthService from './OAuthService';

import {
    Spinner,
    Row, Col,
    Container,
    Form, FormGroup,
    Input,
    Button,
    Alert,
    Toast, ToastHeader, ToastBody
} from 'reactstrap';

class ChangePassword extends Component {
    state = {
        currentPassword: "",
        password: "",
        password2: "",
        responseMsg: "",
        alertMsg: "",
        loading: false,
    }

    constructor(props) {
        super(props);
        this.oas = new OAuthService();
    }

    submitChangePassword = (e) => {
        e.preventDefault();

        if (this.state.password.trim() !== this.state.password2.trim()) {
            this.setState({ alertMsg: "Please make sure your new passwords match." });
            return;
        }

        this.setState({
            loading: true,
            responseMsg: "",
            alertMsg: "",
        }, () => {
            const token = JSON.parse(localStorage.getItem("token"));
            this.oas.changePassword(
                token,
                this.state.currentPassword.trim(),
                this.state.password.trim(),
                this.state.password2.trim()
            ).then(() => {
                this.setState({
                    currentPassword: "",
                    password: "",
                    password2: "",
                    loading: false,
                    responseMsg: "Password updated.",
                });
            }).catch((err) => {
                if (err && err.status === 401) {
                    localStorage.removeItem("token");
                    window.location.href = "/login";
                    return;
                }
                let alertMsg = "Something went wrong. Please try again.";
                if (err && err.body && Array.isArray(err.body.errors) && err.body.errors.length > 0) {
                    alertMsg = err.body.errors;
                }
                this.setState({
                    loading: false,
                    alertMsg: alertMsg,
                });
            });
        });
    }

    setCurrentPassword = (e) => {
        this.setState({ currentPassword: e.target.value });
    }

    setPassword = (e) => {
        this.setState({ password: e.target.value });
    }

    setPassword2 = (e) => {
        this.setState({ password2: e.target.value });
    }

    render() {
        const submitDisabled =
            this.state.currentPassword.trim().length === 0 ||
            this.state.password.trim().length === 0 ||
            this.state.password2.trim().length === 0;

        return (
            <div>
                <Container fluid>
                    <Row className="m-4">
                        <Col>
                            {!this.state.loading &&
                                <Toast className="m-auto">
                                    <ToastHeader>
                                        Change Password
                                    </ToastHeader>
                                    <ToastBody>
                                        <Alert color="success" className="small-box mb-3 text-center" isOpen={this.state.responseMsg ? true : false}>
                                            <div className="text-medium">
                                                {this.state.responseMsg}
                                            </div>
                                        </Alert>
                                        <Alert color="danger" className="small-box mb-3 text-center" isOpen={this.state.alertMsg && !this.state.responseMsg ? true : false}>
                                            <div className="text-medium">
                                                {Array.isArray(this.state.alertMsg)
                                                    ? this.state.alertMsg.map((msg, i) => <div key={i}>{msg}</div>)
                                                    : this.state.alertMsg}
                                            </div>
                                        </Alert>
                                        <Form className="reset-password-form m-auto" onSubmit={this.submitChangePassword}>
                                            <FormGroup>
                                                <Input
                                                    type="password"
                                                    value={this.state.currentPassword}
                                                    onChange={this.setCurrentPassword}
                                                    placeholder="Current Password"
                                                    autoComplete="current-password"
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <Input
                                                    type="password"
                                                    value={this.state.password}
                                                    onChange={this.setPassword}
                                                    placeholder="New Password"
                                                    minLength="4"
                                                    autoComplete="new-password"
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <Input
                                                    type="password"
                                                    value={this.state.password2}
                                                    onChange={this.setPassword2}
                                                    placeholder="Confirm New Password"
                                                    autoComplete="new-password"
                                                />
                                            </FormGroup>
                                            <FormGroup>
                                                <Button type="submit" color="primary"
                                                    disabled={submitDisabled}
                                                    style={{ width: '100%', marginTop: '10px', fontSize: '1em', padding: '2px' }}
                                                >
                                                    Update Password
                                                </Button>
                                            </FormGroup>
                                        </Form>
                                    </ToastBody>
                                </Toast>
                            }
                            {this.state.loading &&
                                <Toast className="m-auto">
                                    <ToastHeader>
                                        Updating...
                                    </ToastHeader>
                                    <ToastBody>
                                        <Spinner color="primary" className="m-auto d-flex" />
                                    </ToastBody>
                                </Toast>
                            }
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </div>
        )
    }
}

export default ChangePassword;
